import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './OrderStatus.scss';

import useResponsive from '../../../hooks/useResponsive';
import { LogoSection } from '../../../Components/LogoSection';
import { OrderSummary } from '../../../Components/OrderSummary';
import {
  Header,
  Subtitle,
  Title,
  Text,
  Subheader,
} from '../../../Components/Typography';
import useDatabase from '../../../hooks/useDatabase';
import {
  AdminContext,
  AdminContextProps,
} from '../../../Contexts/AdminContext';
import { isEmpty } from '../../../utils/isEmpty';
import { routes } from '../../../Router';

export const OrderStatus = () => {
  let { trackingCode } = useParams();
  const navigate = useNavigate();

  const { isDesktopOrLaptop } = useResponsive();
  const { getCollectionByTrackingCode } = useDatabase();

  const {
    orders,
    formatOrders,
    selectedOrder,
    setSelectedOrder,
    TrackingshippingCode,
  }: AdminContextProps = useContext<any>(AdminContext);

  useEffect(() => {
    const init = async () => {
      const results = await getCollectionByTrackingCode(
        'view_order',
        trackingCode ?? ''
      );

      if (results && results.length > 0) {
        formatOrders(results);
      } else {
        toast.error(`Pedido no encontrado: ${trackingCode}`);
        navigate(routes.clientLogin.path);
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orders && orders.length > 0) {
      setSelectedOrder(orders[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  return (
    selectedOrder && (
      <div
        className={
          isDesktopOrLaptop ? 'order-status-desktop' : 'order-status-mobile'
        }
      >
        <LogoSection style={{ marginRight: '10px' }} />

        {isDesktopOrLaptop && (
          <OrderSummary
            isPreview
            showPaymentForm
            style={{ marginLeft: '180px' }}
          />
        )}

        <div className="main-column">
          <div className="text-section">
            <div className="block">
              <Subheader>Estado del pedido</Subheader>
              <Subtitle>{selectedOrder.status}</Subtitle>
            </div>

            <div className="block">
              <Text>
                Recibirá un email una vez que el pedido haya sido terminado.{' '}
              </Text>
              <Text>
                En caso de no recibirlo, también puede hacer el seguimiento en
                esta página.
              </Text>
            </div>

            <div className="block">
              <Title secondary>{trackingCode}</Title>
            </div>
            <div className="block">
              <Text bold>
                A la hora de retirar su pedido, deberá presentar este código o
                el email que utilizó para realizarlo.
              </Text>
            </div>
            <div className="block">
              <div
                className="flex-row-top"
                style={{ gap: '50px', marginTop: '20px' }}
              >
                {!isEmpty(selectedOrder.sucursal) ? (
                  <div className="flex-column">
                    <Subheader bold>Retiro por local</Subheader>
                    <Text>{selectedOrder.sucursal}</Text>
                    <Text>{selectedOrder.sucursal_address}</Text>
                  </div>
                ) : (
                  <div className="flex-column">
                    <Subheader bold>Datos de envío</Subheader>
                    <Text bold>Dirección</Text>

                    <Text>{selectedOrder.address_send?.address}</Text>
                    <Text>{selectedOrder.address_send?.addressDetails}</Text>
                    <Text>{selectedOrder.address_send?.location}</Text>
                    <Text>{selectedOrder.address_send?.province.text}</Text>
                    <Text>{selectedOrder.address_send?.postalCode}</Text>

                    {selectedOrder.address_send &&
                      (selectedOrder.id_status === 3 ||
                        selectedOrder.id_status === 4) && (
                        <div
                          style={{ marginTop: '20px', cursor: 'pointer' }}
                          onClick={() =>
                            TrackingshippingCode(1, selectedOrder.shipping_code)
                          }
                        >
                          <p>
                            <a className="hyperlink">
                              Consulta aquí el seguimiento de tu envío.
                            </a>
                          </p>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {!isDesktopOrLaptop && <OrderSummary isPreview showPaymentForm />}
        </div>
      </div>
    )
  );
};
